
export const PagoFallido = () => {
  return (
    <div>
        <header>    
            <div className='texto-header d-flex flex-row'>
            </div>
        </header>

        <h1>Pago Fallido!</h1>
    </div>
  )
}

